import React, {createContext, useEffect, useState} from "react";
import {useLazyQuery} from "@apollo/client";
import moment from "moment";

import {FETCH_UPDATES} from "../queries/GraphQLQueries";
import {useCurrentUser} from "../hooks/useCurrentUser";
import {StorageKeys} from "../constants/StorageKeys";
import {ApolloFetchPolicies} from "../constants/FetchPolicies";

export const UpdatedObjectCountContext = createContext();

export const UpdatedObjectCountProvider = ({children, keystore}) => {

    const {currentUser} = useCurrentUser();
    const [updatedShiftCount, setUpdatedShiftCount] = useState(0);

    const [fetchShiftUpdate, {data}] = useLazyQuery(FETCH_UPDATES);

    useEffect(() => {
        fetchDataUpdates();
    }, [currentUser]);

    useEffect(() => {

        if (!data?.updates) {
            return;
        }

        setUpdatedShiftCount(data.updates.shiftUpdates);
    }, [data]);

    const getDefaultUpdateCheckTime = () => moment().toDate();

    const resetDataUpdateCount = () => {
        setUpdatedShiftCount(0);
        keystore.setKey(StorageKeys.LAST_SHIFT_UPDATE_CHECK_TIME, getDefaultUpdateCheckTime());
    }

    const fetchDataUpdates = (fetchPolicy = ApolloFetchPolicies.NETWORK_ONLY) => {

        if (!currentUser?.id) {
            return;
        }

        fetchShiftUpdate({
            variables: {
                userId: currentUser?.id,
                timeToCheckShiftsAfter: keystore.getKeyOrDefault(StorageKeys.LAST_SHIFT_UPDATE_CHECK_TIME, getDefaultUpdateCheckTime())
            }, fetchPolicy
        });
    }

    return (
      <UpdatedObjectCountContext.Provider value={{updatedShiftCount, resetDataUpdateCount, fetchDataUpdates, keystore}}>
          {children}
      </UpdatedObjectCountContext.Provider>
    );
}
